import PropTypes from 'prop-types';
import ResidentIDHelper from '../../helpers/ResidentIDHelper';
import DetailedTooltip from '../DetailedTooltip';

export default function ResidentIdTooltip(props) {
  return (
    <DetailedTooltip title="checkout.address.field.label.residentId.title" tooltipID={props.tooltipID}>
      <ResidentIDHelper />
    </DetailedTooltip>
  );
}

ResidentIdTooltip.propTypes = {
  tooltipID: PropTypes.string,
};
